var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-deal-agreement-V3H6YDKEGJ 1",
    clipPath: "url(#clip0_121_4547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.1312 21.9837C35.8912 21.9837 35.6506 21.8925 35.4681 21.71L26.6287 12.8706C26.2631 12.505 26.2631 11.9106 26.6287 11.545L29.06 9.11437C29.425 8.74874 30.0206 8.74874 30.3856 9.11437L39.2243 17.9531C39.4012 18.13 39.4987 18.3656 39.4987 18.6162C39.4987 18.8669 39.4012 19.1019 39.2243 19.2794L36.7937 21.71C36.6112 21.8925 36.3706 21.9837 36.1312 21.9837ZM29.7231 9.46499C29.6431 9.46499 29.5631 9.49499 29.5018 9.55624L27.0706 11.9869C26.9487 12.1087 26.9487 12.3069 27.0706 12.4287L35.91 21.2675C36.0318 21.3894 36.23 21.3894 36.3518 21.2675L38.7825 18.8369C38.8418 18.7781 38.8737 18.7 38.8737 18.6162C38.8737 18.5331 38.8412 18.4544 38.7825 18.395L29.9437 9.55624C29.8825 9.49562 29.8031 9.46499 29.7231 9.46499Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.53185 23.0881C4.29185 23.0881 4.05185 22.9969 3.86872 22.8144L0.775596 19.72C0.598721 19.5431 0.501221 19.3075 0.501221 19.0569C0.501221 18.8069 0.598721 18.5713 0.775596 18.3938L9.61435 9.55626C9.97935 9.19064 10.575 9.19064 10.94 9.55626L14.0337 12.65C14.2106 12.8269 14.3081 13.0625 14.3081 13.3131C14.3081 13.5638 14.2106 13.7994 14.0337 13.9763L5.19497 22.8144C5.01247 22.9969 4.77185 23.0881 4.53185 23.0881ZM10.2768 9.90689C10.1968 9.90689 10.1168 9.93689 10.0556 9.99814L1.21747 18.8369C1.1581 18.8963 1.12622 18.9744 1.12622 19.0581C1.12622 19.1419 1.15872 19.22 1.21747 19.2788L4.3106 22.3725C4.43247 22.4938 4.6306 22.4944 4.75247 22.3725L13.5918 13.5338C13.6512 13.4744 13.6831 13.3963 13.6831 13.3125C13.6831 13.2294 13.6506 13.1506 13.5918 13.0913L10.4981 9.99751C10.4368 9.93751 10.3568 9.90689 10.2768 9.90689Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.8501 31.5237C26.7701 31.5237 26.6901 31.4931 26.6289 31.4325L20.442 25.2449C20.3201 25.1231 20.3201 24.925 20.442 24.8031C20.5639 24.6812 20.762 24.6812 20.8839 24.8031L27.0707 30.9906C27.1926 31.1124 27.1926 31.3106 27.0707 31.4325C27.0101 31.4937 26.9301 31.5237 26.8501 31.5237Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.1988 33.2919C24.1188 33.2919 24.0388 33.2613 23.9775 33.2006L18.2325 27.4556C18.1106 27.3338 18.1106 27.1356 18.2325 27.0138C18.3544 26.8919 18.5525 26.8919 18.6744 27.0138L24.4194 32.7588C24.5413 32.8806 24.5413 33.0788 24.4194 33.2006C24.3588 33.2613 24.2788 33.2919 24.1988 33.2919Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.2657 31.3175C11.7857 31.3175 11.3057 31.135 10.9401 30.7694C10.2094 30.0388 10.2094 28.8488 10.9401 28.1175L12.5976 26.4606C13.3057 25.7525 14.5407 25.7519 15.2488 26.4606C15.6026 26.8144 15.7982 27.2856 15.7982 27.7863C15.7982 28.2869 15.6032 28.7581 15.2488 29.1125L13.5919 30.7694C13.2263 31.135 12.7463 31.3175 12.2657 31.3175ZM11.3819 30.3275C11.8688 30.8156 12.6632 30.8144 13.1501 30.3275L14.8069 28.6706C15.0432 28.4344 15.1732 28.1206 15.1732 27.7863C15.1732 27.4519 15.0432 27.1388 14.8069 26.9025C14.3344 26.43 13.5119 26.43 13.0394 26.9025L11.3819 28.5594C10.8951 29.0469 10.8951 29.84 11.3819 30.3275Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.0337 33.9694C13.5531 33.9694 13.0737 33.7869 12.7081 33.4213C12.3543 33.0675 12.1587 32.5963 12.1587 32.0956C12.1587 31.595 12.3537 31.1238 12.7081 30.7694L14.8068 28.6706C15.5374 27.94 16.7268 27.9394 17.4587 28.6706C18.1893 29.4013 18.1893 30.5913 17.4587 31.3225L15.3593 33.4213C14.9937 33.7869 14.5143 33.9694 14.0337 33.9694ZM16.1331 28.7469C15.8124 28.7469 15.4924 28.8688 15.2487 29.1125L13.1499 31.2113C12.9137 31.4475 12.7837 31.7613 12.7837 32.0956C12.7837 32.43 12.9137 32.7431 13.1499 32.9794C13.6368 33.4663 14.4306 33.4663 14.9174 32.9794L17.0168 30.8806C17.5037 30.3931 17.5037 29.6 17.0168 29.1125C16.7737 28.8681 16.4531 28.7469 16.1331 28.7469Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.6851 35.7369C16.2051 35.7369 15.7251 35.5544 15.3595 35.1888C14.6282 34.4575 14.6282 33.2681 15.3595 32.5369L17.0163 30.8794C17.7476 30.1494 18.937 30.1475 19.6682 30.8794C20.022 31.2338 20.2176 31.7044 20.2176 32.2056C20.2176 32.7069 20.0226 33.1775 19.6682 33.5313L18.0113 35.1888C17.6457 35.5544 17.1657 35.7369 16.6851 35.7369ZM15.8013 34.7469C16.2882 35.2344 17.0826 35.2331 17.5695 34.7469L19.2263 33.0894C19.4626 32.8531 19.5926 32.5394 19.5926 32.2056C19.5926 31.8719 19.4626 31.5575 19.2263 31.3213C18.7388 30.8338 17.9445 30.835 17.4582 31.3213L15.8013 32.9788C15.3138 33.4663 15.3138 34.2594 15.8013 34.7469Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.3314 37.4993C18.8514 37.4993 18.3714 37.3168 18.0057 36.9512C17.2751 36.22 17.2751 35.0306 18.0057 34.2993L19.2214 33.0837C19.9289 32.3762 21.1639 32.375 21.8726 33.0837C22.2264 33.4381 22.422 33.9087 22.422 34.41C22.422 34.9112 22.227 35.3818 21.8726 35.7356L20.6576 36.9512C20.292 37.3162 19.8114 37.4993 19.3314 37.4993ZM18.4476 36.5093C18.9351 36.9968 19.7295 36.9962 20.2157 36.5093L21.4307 35.2937C21.667 35.0575 21.797 34.7437 21.797 34.41C21.797 34.0762 21.667 33.7618 21.4307 33.5256C20.9582 33.0537 20.1357 33.0537 19.6632 33.5256L18.4476 34.7412C17.9601 35.2287 17.9601 36.0212 18.4476 36.5093Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.0788 28.0106C9.9988 28.0106 9.9188 27.98 9.85755 27.9193L5.63755 23.6981C5.51567 23.5762 5.51567 23.3781 5.63755 23.2562C5.75942 23.1343 5.95755 23.1343 6.07942 23.2562L10.3 27.4768C10.4219 27.5987 10.4219 27.7968 10.3 27.9187C10.2388 27.9806 10.1588 28.0106 10.0788 28.0106Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.4462 15.5982C22.3662 15.5982 22.2855 15.5675 22.2249 15.5063L22.1274 15.4082C21.8374 15.1175 21.4349 14.9513 21.023 14.9513H14.6968C14.5243 14.9513 14.3843 14.8113 14.3843 14.6388C14.3843 14.4663 14.5243 14.3263 14.6968 14.3263H21.023C21.5987 14.3263 22.1624 14.56 22.5699 14.9669L22.668 15.065C22.7893 15.1875 22.7893 15.385 22.6668 15.5069C22.6062 15.5675 22.5262 15.5982 22.4462 15.5982Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.1364 35.9363C23.1114 35.9363 23.0864 35.9356 23.0607 35.935C22.8889 35.9288 22.7539 35.7838 22.7601 35.6113C22.767 35.4394 22.8901 35.2938 23.0845 35.3106C23.2945 35.3194 23.6076 35.28 23.882 35.0556C24.1614 34.8275 24.3251 34.505 24.3426 34.1475C24.3601 33.795 24.227 33.4494 23.9782 33.2C23.8564 33.0781 23.8564 32.88 23.9782 32.7581C24.1001 32.6363 24.2982 32.6363 24.4201 32.7581L24.4226 32.7606L24.7995 33.1375C25.2839 33.6219 26.0451 33.6875 26.5332 33.2881C26.8126 33.0594 26.9764 32.7363 26.9945 32.3794C27.0114 32.0275 26.8789 31.6819 26.6295 31.4331C26.5076 31.3113 26.5076 31.1131 26.6295 30.9913C26.7514 30.8694 26.9495 30.8694 27.0714 30.9913C27.0726 30.9925 27.0739 30.9931 27.0751 30.9944L27.5132 31.4331C27.7626 31.6825 28.1076 31.82 28.4607 31.7975C28.8176 31.7794 29.1401 31.6156 29.3689 31.3363C29.7682 30.8475 29.702 30.0863 29.2182 29.6019L20.442 20.8256C20.3201 20.7038 20.3201 20.5056 20.442 20.3838C20.5639 20.2619 20.762 20.2619 20.8839 20.3838L29.6595 29.1594C30.3682 29.8675 30.4526 30.9975 29.852 31.7313C29.5157 32.1431 29.0195 32.395 28.492 32.4213C28.1851 32.4375 27.8901 32.3775 27.6195 32.2544C27.6214 32.3063 27.6214 32.3581 27.6182 32.41C27.592 32.9381 27.3407 33.4344 26.9282 33.7713C26.3814 34.2188 25.6157 34.2863 24.9664 33.9981C24.9695 34.0581 24.9695 34.1181 24.9664 34.1788C24.9401 34.7069 24.6889 35.2025 24.2764 35.5394C23.9589 35.7994 23.5657 35.9363 23.1364 35.9363Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16.2438 22.8562C15.7232 22.8562 15.2032 22.6581 14.8069 22.2619C14.4232 21.8781 14.2119 21.3681 14.2119 20.8256C14.2119 20.2831 14.4232 19.7731 14.8069 19.3894L16.3569 17.8394C16.77 17.4262 17.3194 17.1987 17.9038 17.1987H21.8588L25.745 13.3125C25.8669 13.1906 26.065 13.1906 26.1869 13.3125C26.3088 13.4344 26.3088 13.6325 26.1869 13.7544L22.2094 17.7319C22.1507 17.7906 22.0713 17.8231 21.9882 17.8231H17.9038C17.4863 17.8231 17.0938 17.9856 16.7988 18.2806L15.2488 19.8306C14.9832 20.0962 14.8369 20.4494 14.8369 20.825C14.8369 21.2006 14.9832 21.5537 15.2488 21.8194C15.7975 22.3681 16.6907 22.3669 17.2382 21.8194L19.5582 19.4994C19.68 19.3775 19.8782 19.3775 20 19.4994C20.1219 19.6212 20.1219 19.8194 20 19.9412L17.68 22.2612C17.2838 22.6581 16.7638 22.8562 16.2438 22.8562Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M29.4955 27.9825C29.4155 27.9825 29.3355 27.9518 29.2743 27.8912C29.1524 27.7693 29.1524 27.5712 29.2743 27.4493L34.5774 22.1462C34.6993 22.0243 34.8974 22.0243 35.0193 22.1462C35.1411 22.2681 35.1411 22.4662 35.0193 22.5881L29.7161 27.8912C29.6555 27.9525 29.5755 27.9825 29.4955 27.9825Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M19.0625 8.75H16.5625C16.39 8.75 16.25 8.61 16.25 8.4375C16.25 8.265 16.39 8.125 16.5625 8.125H19.0625C19.235 8.125 19.375 8.265 19.375 8.4375C19.375 8.61 19.235 8.75 19.0625 8.75Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M17.8125 10C17.64 10 17.5 9.86 17.5 9.6875V7.1875C17.5 7.015 17.64 6.875 17.8125 6.875C17.985 6.875 18.125 7.015 18.125 7.1875V9.6875C18.125 9.86 17.985 10 17.8125 10Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M23.4375 4.375H20.9375C20.765 4.375 20.625 4.235 20.625 4.0625C20.625 3.89 20.765 3.75 20.9375 3.75H23.4375C23.61 3.75 23.75 3.89 23.75 4.0625C23.75 4.235 23.61 4.375 23.4375 4.375Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M22.1875 5.625C22.015 5.625 21.875 5.485 21.875 5.3125V2.8125C21.875 2.64 22.015 2.5 22.1875 2.5C22.36 2.5 22.5 2.64 22.5 2.8125V5.3125C22.5 5.485 22.36 5.625 22.1875 5.625Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M0.9375 36.5625H0.3125C0.14 36.5625 0 36.4225 0 36.25C0 36.0775 0.14 35.9375 0.3125 35.9375H0.9375C1.11 35.9375 1.25 36.0775 1.25 36.25C1.25 36.4225 1.11 36.5625 0.9375 36.5625Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M9.0625 36.5625H2.1875C2.015 36.5625 1.875 36.4225 1.875 36.25C1.875 36.0775 2.015 35.9375 2.1875 35.9375H9.0625C9.235 35.9375 9.375 36.0775 9.375 36.25C9.375 36.4225 9.235 36.5625 9.0625 36.5625Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M39.6875 36.5625H39.0625C38.89 36.5625 38.75 36.4225 38.75 36.25C38.75 36.0775 38.89 35.9375 39.0625 35.9375H39.6875C39.86 35.9375 40 36.0775 40 36.25C40 36.4225 39.86 36.5625 39.6875 36.5625Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M37.8125 36.5625H30.9375C30.765 36.5625 30.625 36.4225 30.625 36.25C30.625 36.0775 30.765 35.9375 30.9375 35.9375H37.8125C37.985 35.9375 38.125 36.0775 38.125 36.25C38.125 36.4225 37.985 36.5625 37.8125 36.5625Z",
    fill: "#1C2541",
    stroke: "#1C2541",
    strokeWidth: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_4547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService10);
export default __webpack_public_path__ + "static/media/service10.0f7ed0da31b5995b37b179a0a90bc42f.svg";
export { ForwardRef as ReactComponent };